import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/hooks/usePageTitle";

import { DashboardWalletWidget } from "./_components/dashboard-wallet-widget";
import { TimeSummery } from "./_components/TimeSummery";
import { LeaveBalancesWidget } from "./_components/leave-balances-widget";
import { UpcomingEventsWidget } from "./_components/upcoming-events-widget";
import { DashboardBanner } from "./_components/dashboard-banner";
import AttendanceTimerActionBar from "./_components/attendance-timer-action-bar";
import { AnnouncementsWidget } from "./_components/announcements-widget";
import { AttendanceExceptionsWidget } from "./_components/attendance-exceptions-widget";
import { withBranding } from "@/utils/helper";

const Dashboard = () => {
  const { t } = useTranslation("my-space");
  usePageTitle(withBranding(t("page_titles.home")));
  return (
    <div className="h-full flex flex-col">
      <DashboardBanner />
      <AttendanceTimerActionBar />
      <div className="grid grid-cols-1 min-[950px]:grid-cols-3 min-[950px]:grid-rows-[280px_1fr] gap-3 mt-4">
        <TimeSummery className="min-h-0!" />
        <LeaveBalancesWidget className="min-h-0!" />
        <DashboardWalletWidget className="min-[950px]:min-h-0!" />
        <UpcomingEventsWidget />
        <AttendanceExceptionsWidget />
        {/* <Anniversary isAnniversary={true} /> TO BE SED IN FUTURE IF NEEDED */}
        <AnnouncementsWidget platformSectionType="ALL" limit={5} />
      </div>
    </div>
  );
};

export default Dashboard;
